import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const isFor = ['Mujeres que son el pilar culinario de su familia y quieren ser recordadas.', 'Abuelas que desean dejar un regalo invaluable y eterno a sus nietos.', 'Madres que conservan recetas de sus antepasados y temen que se pierdan.', 'Seguidoras de la tradición que creen que la comida es el lenguaje del amor.'];
  const isNotFor = ['Personas que buscan recetas rápidas de microondas o dietas de moda.', 'Quienes no valoran la historia familiar ni las tradiciones latinas.', 'Gente que prefiere comprar comida procesada en lugar de cocinar en casa.'];
  return <section className="py-24 bg-heritage-beige" data-id="element-36">
      <div className="max-w-6xl mx-auto px-6" data-id="element-37">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-38">
          {/* Who this is for */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border-t-4 border-heritage-terracotta" data-id="element-39">
            <FadeIn data-id="element-40">
              <h3 className="font-serif text-2xl md:text-3xl font-bold mb-8 text-heritage-coffee" data-id="element-41">
                Este sistema es{' '}
                <span className="text-heritage-terracotta italic" data-id="element-42">PARA TI</span>{' '}
                si:
              </h3>
            </FadeIn>
            <StaggerContainer className="space-y-6" data-id="element-43">
              {isFor.map((item, idx) => <StaggerItem key={idx} className="flex gap-4" data-id="element-44">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-1" data-id="element-45">
                    <Check className="w-4 h-4 text-green-700" data-id="element-46" />
                  </div>
                  <p className="text-heritage-coffee/90 text-lg" data-id="element-47">{item}</p>
                </StaggerItem>)}
            </StaggerContainer>
          </div>

          {/* Who this is not for */}
          <div className="bg-heritage-cream rounded-2xl p-8 md:p-10 border border-heritage-coffee/10 opacity-90" data-id="element-48">
            <FadeIn data-id="element-49">
              <h3 className="font-serif text-2xl md:text-3xl font-bold mb-8 text-heritage-coffee/60" data-id="element-50">
                Esto <span className="italic" data-id="element-51">NO ES</span> para:
              </h3>
            </FadeIn>
            <StaggerContainer className="space-y-6" data-id="element-52">
              {isNotFor.map((item, idx) => <StaggerItem key={idx} className="flex gap-4" data-id="element-53">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-1" data-id="element-54">
                    <X className="w-4 h-4 text-red-700" data-id="element-55" />
                  </div>
                  <p className="text-heritage-coffee/70 text-lg" data-id="element-56">{item}</p>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}